import React from 'react';
import { Chip } from '@nextui-org/react';
import { PatientParamValues } from '@/types/models';
import logger from '@/layers/support/monitoring/logger';
import { useGlobalState } from '@/layers/presentation/context/GlobalStateContext';
import { getPatientParamValuesExtended } from '@/layers/presentation/services/patients';

const LOG_MODULE = 'FE [Presentation / Components / Tags]';

interface TagsProps {
  params: PatientParamValues;
}

const renderChipGroup = (paramName: string, values: { value: number; label: string }[]) => {
  if (values.length === 0) return null;

  return (
    <div key={paramName} className="flex flex-row items-center gap-2">
      <span className="text-xs text-default-500">{paramName}:</span>
      <div className="flex flex-wrap gap-1">
        {values.map(value => (
          <Chip key={value.value} variant="bordered" size="sm" className="border-1">
            {value.label}
          </Chip>
        ))}
      </div>
    </div>
  );
};

export default function Tags({ params }: TagsProps) {
  const { patientParamsDictionary } = useGlobalState();
  const paramsFull = getPatientParamValuesExtended(patientParamsDictionary, params);

  logger.debug(`${LOG_MODULE} - Render`, { params, patientParamsDictionary, paramsFull });

  return (
    <div className="flex flex-row gap-4">
      {Object.entries(paramsFull).map(([_, paramData]) =>
        renderChipGroup(paramData.param.name, paramData.values),
      )}
    </div>
  );
}
